import styled from "styled-components";

import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";
import { Text } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const AffinityCellContainer = styled(FlexRow)`
    align-items: center;
    .sw-progress-bar {
        flex: 1;
    }
`;

const TextFixedSize = styled(Text)`
    width: 24px;
    margin: auto 12px auto 0;
`;

export const KeywordCompetitorsAffinityCell = ({ row, value }: { row?: { Affinity: number }; value?: number }) => {
    // can be value or a full row
    const affinity = value || row?.Affinity;

    return (
        <AffinityCellContainer justifyContent="space-between">
            {/* @ts-ignore FIXME: Type 'undefined' is not assignable to type 'number' */}
            <TextFixedSize>{Math.round(affinity)}</TextFixedSize>
            <ProgressBar
                // @ts-ignore FIXME: Type 'undefined' is not assignable to type 'number'
                width={Math.round(affinity)}
                height={8}
            />
        </AffinityCellContainer>
    );
};
